import config from 'config';
import { http_client } from './api';

// Data murid aktif (semua)
const getActiveList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'student-accounting/active?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getActiveDetail = async (id) => {
  return http_client.get(config.apiUrl + 'student-accounting/active/' + id).then((response) => {
    return response.data;
  });
};

// Data murid bulan ini (yang baru diaktifkan)
const getNewmonthList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'student-accounting/newmonth?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getNewmonthDetail = async (id) => {
  return http_client.get(config.apiUrl + 'student-accounting/newmonth/' + id).then((response) => {
    return response.data;
  });
};

// Data murid pending
const getPendingList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'student-accounting/pending?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getPendingDetail = async (id) => {
  return http_client.get(config.apiUrl + 'student-accounting/pending/' + id).then((response) => {
    return response.data;
  });
};

const StudentAccountingService = {
  getActiveList,
  getActiveDetail,
  getNewmonthList,
  getNewmonthDetail,
  getPendingList,
  getPendingDetail
};

export default StudentAccountingService;

